import React from 'react';

import DateRangeFilter from 'dashboard/components/DateRangeFilter';
import SiteFilter from 'dashboard/components/SiteFilter';

import * as Styled from 'dashboard/styles/Dashboard.style';

interface DashboardFiltersProps {
  fromDate: string;
  toDate: string;
  siteIds: string[];
  onDateRangeChange: (from: string, to: string) => void;
  onSiteIdsChange: (ids: string[]) => void;
}

export default function DashboardFilters({
  fromDate,
  toDate,
  siteIds,
  onDateRangeChange,
  onSiteIdsChange,
}: DashboardFiltersProps): JSX.Element {
  return (
    <Styled.FiltersRow>
      <DateRangeFilter
        fromDate={fromDate}
        toDate={toDate}
        onDateRangeChange={onDateRangeChange}
      />
      <SiteFilter siteIds={siteIds} onSiteIdsChange={onSiteIdsChange} />
    </Styled.FiltersRow>
  );
}
